import { gql } from '@apollo/client';

export const SET_STORE_PRICE_MARGINS = gql`
  mutation SetStorePriceMargins($input: SetStorePriceMarginsInput!) {
    setStorePriceMargins(input: $input) {
      storeId
      merchMargin
      streamMargin
      amaMargin
      tipMargin
      productMargin
    }
  }
`;
